import { render, staticRenderFns } from "./DailyLessons.vue?vue&type=template&id=023273a2"
import script from "./DailyLessons.vue?vue&type=script&lang=js"
export * from "./DailyLessons.vue?vue&type=script&lang=js"
import style0 from "./DailyLessons.vue?vue&type=style&index=0&id=023273a2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports